import * as v from "valibot";

// request schema
export const ConfigSchema = v.record(v.string(), v.string());
export type Config = v.InferOutput<typeof ConfigSchema>;

export const RequestSchema = v.object({
  ClusterId: v.string(),
  Config: ConfigSchema,
  InstanceId: v.string(),
  Name: v.string(),
  Type: v.string(),
  AddonVersion: v.string(),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response schema
export const DataSchema = v.object({
  ClusterId: v.string(),
  InstanceId: v.string(),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
});
export type Response = v.InferOutput<typeof ResponseSchema>;
